import { useState, useCallback } from 'react';
import { updateMaterialStatus, assingMaterialsState } from '@auteco/services/snopServices';
import { initialAlert, statesSnop } from '@auteco/constants';

export const useMaterialManagement = (materials, setMaterials, getMaterialsProfile) => {
  const [alertInfo, setAlertInfo] = useState(initialAlert);
  const [idSaved, setIdSaved] = useState(null);

  const updateMaterial = useCallback(async ({ material, status }) => {
    const { success } = await updateMaterialStatus({ 
      params: { material, estado: status } 
    });

    if (success === 1) {
      setAlertInfo(initialAlert);
      const updatedMaterials = materials.map((item) =>
        item.id === material ? { ...item, fc: status } : item
      );
      setMaterials(updatedMaterials);
    }
  }, [materials, setMaterials]);

  const onCloseAlert = useCallback(() => {
    setAlertInfo(initialAlert);
  }, []);

  const onPassMaterial = useCallback(({ material }) => {
    setAlertInfo({
      title: '¡Espera!',
      content: 'Estás a punto de saltar un material.',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: () => updateMaterial({ material, status: statesSnop.dudas }),
    });
  }, [onCloseAlert, updateMaterial]);

  const handleFinishMaterial = useCallback(({ material }) => {
    setAlertInfo({
      title: '¡Espera!',
      content: 'Estás a punto de Finalizar un material.',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: () => updateMaterial({ material, status: statesSnop.finalizado }),
    });
  }, [onCloseAlert, updateMaterial]);

  const onAssignMaterials = useCallback(async (selectedMaterials) => {
    if (selectedMaterials.length === 0) {
      alert('Selecciona al menos un material');
      return;
    }

    const materiales = selectedMaterials.map(material => material.id);
    const response = await assingMaterialsState({ 
      params: { estado: 1, materiales } 
    });

    if (response && idSaved) {
      getMaterialsProfile({ id: idSaved });
    }
  }, [idSaved, getMaterialsProfile]);

  return {
    alertInfo,
    idSaved,
    setIdSaved,
    updateMaterial,
    onCloseAlert,
    onPassMaterial,
    handleFinishMaterial,
    onAssignMaterials
  };
};
